import { useEffect, useState } from 'react';
import { Focus, Link as LinkIcon, Minus, Plus } from 'lucide-react';

export default function ReadingTools({slug}: {slug:string}) {
  const [size,setSize]=useState(0);
  const [quiet,setQuiet]=useState(false);
  const [status,setStatus]=useState('');
  useEffect(()=>{
    const article=document.querySelector<HTMLElement>('.journal-post');
    if(!article)return;
    article.style.setProperty('--article-size',`${18+size*2}px`);
    article.classList.toggle('reading-quiet',quiet);
    return()=>{article.style.removeProperty('--article-size');article.classList.remove('reading-quiet');};
  },[size,quiet,slug]);
  return <div className="container reader-tools"><div className="reader-toolbar" aria-label="Reading preferences">
    <span>Make yourself comfortable</span>
    <div className="reader-size"><button disabled={size===0} onClick={()=>setSize(s=>s-1)} aria-label="Decrease article text size"><Minus size={17}/></button><span aria-live="polite">{18+size*2}px</span><button disabled={size===2} onClick={()=>setSize(s=>s+1)} aria-label="Increase article text size"><Plus size={17}/></button></div>
    <button aria-pressed={quiet} onClick={()=>setQuiet(!quiet)}><Focus size={17}/><span>Quiet reading</span></button>
    <button onClick={async()=>{try{await navigator.clipboard.writeText(window.location.href);setStatus('Story link copied.');}catch{setStatus('Copy the story URL from your browser’s address bar.');}}}><LinkIcon size={17}/><span>Share story</span></button>
  </div><p className="reader-status" role="status">{status}</p></div>;
}
